export const FEATURE_FLAGS = {
  autoPools: process.env.REACT_APP_IS_AUTO_POOL_ENABLED === 'true'
}
